import { lazy } from 'react';

// project imports
import NavigationScroll from 'layout/NavigationScroll';
import GuestGuard from 'utils/route-guard/GuestGuard';
import MinimalLayout from 'layout/MinimalLayout';
import NavMotion from 'layout/NavMotion';
import Loadable from 'ui-component/Loadable';

// login routing
const AuthLogin = Loadable(lazy(() => import('views/pages/authentication/Login1')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
    path: '/',
    element: (
        <NavigationScroll>
            <NavMotion>
                <GuestGuard>
                    <MinimalLayout />
                </GuestGuard>
            </NavMotion>
        </NavigationScroll>
    ),
    children: [
        {
            path: '/',
            element: <AuthLogin />
        },
        {
            path: '/login',
            element: <AuthLogin />
        }
    ]
};

export default LoginRoutes;
